import hrx from "../../Assets/HRX.png"
import handbag from "../../Assets/Handbag.png"
import amazon from "../../Assets/Amazon.png"
import bewakoof from "../../Assets/Bewakoof.png"
const images = [
    {
        id: 1,
        img: bewakoof

    },
    {
        id: 2,
        img: "https://djp-digital.web.app/static/media/1.4a4c0ea6.jpg"
    },
    {
        id: 3,
        img: "https://djp-digital.web.app/static/media/2.c8fdbd2c.jpg"
    },
    {
        id: 4,
        img: hrx
    },
    {
        id: 5,
        img: handbag
    },
    {
        id: 6,
        img: amazon
    },
]

export default images;